import appGlobalScript from 'C:/Data/Daten/gitRepos/desi-code/stzh-components/src/global/js/script.js';
export const globalScripts = appGlobalScript;
